import styled from 'styled-components';
import { brand } from 'themes/brand';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

export const BaseDeleteForeverIcon = styled(DeleteForeverIcon)`
  color: ${brand.textSecondary};
  margin-right: 15px;

  :hover {
    cursor: pointer;
    color: ${brand.text};
  }
`;

export const Container = styled.div`
  padding: 30px 20px 30px 0;
`;
